import React, {FC} from 'react';
import {Stack, Typography} from "@mui/material";
import EditCompanyProfile from "./EditCompanyProfile/EditCompanyProfile";
import AdminInfo from "./AdminInfo";
import {hasAdminAccess, isSupplierAccount} from "../../util/AccountUtils";
import {Account} from "../../types/Account";

interface CompanyProfile {
  account: Account,
  handleAccountUpdated: (account: Account) => void,
}

const CompanyProfile: FC<CompanyProfile> = ({ account, handleAccountUpdated }) => {
  return (
    <Stack component={'article'} gap={'1.71rem'}>
      <Stack gap={'0.29rem'}>
        <Typography variant={'h5'} component={'h1'} color={'textPrimary'}>Company Details</Typography>
        {account?.companyName &&
          <Typography variant={'body2'} color={'textSecondary'}>{account.companyName} · {account.type} account</Typography>
        }
      </Stack>
      {/* Every admin field is supplier-only, so other account types would get an empty section. */}
      {hasAdminAccess(account) && isSupplierAccount(account) &&
        <AdminInfo
          account={account}
          handleAccountUpdated={handleAccountUpdated}
        />
      }
      {account &&
        <EditCompanyProfile
          account={account}
          handleAccountUpdated={handleAccountUpdated}
        />
      }
    </Stack>
  );
};

export default CompanyProfile;
